<template>
  <div id="app" :key="Date.parse(new Date())/1000">
    <router-view/>
  </div>
</template>

<script>
import { logout } from '@/api/api';
export default {
  name: 'App',

  data () {
    return {
      _beforeUnload_time: '',
      _gap_time: ''
    }
  },

  methods: {
    async logout(){
      await logout({}).then((res) => {
      }).catch((res) => {
        console.error(res)
      })
      
    },
  },

  mounted(){
    // window.addEventListener('beforeunload', e => {
      // this._beforeUnload_time = new Date().getTime()
    // })
    // window.addEventListener('unload', async () => {
    //   this._gap_time = new Date().getTime() - this._beforeUnload_time
    // //   this.common.setCookie('b',this._beforeUnload_time);
    // //   this.common.setCookie('u',this._gap_time);
    //   if (this._gap_time <= 5) {
    //     this.common.delCookie('userInfo');
    //     this.common.delStorage('userInfo');
    //     this.logout()
    //   } else {
    // //     // 刷新
    //   }
    // })
  },
  destroyed() {
    window.removeEventListener('beforeunload')
    window.removeEventListener('unload')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ./src/App.vue